module.exports = __webpack_public_path__ + "img/program-price.6d72ef9c.png";